var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"w-4",attrs:{"src":'/flags/market/' + _vm.countryCodeLower + '.svg',"alt":_vm.countryName,"loading":"lazy","height":"10","width":"16"}})
}
var staticRenderFns = []

export { render, staticRenderFns }